import { get_json, post_json, delete_json } from './util';

// Promise-based wrappers for API calls
const API = {
  get: (path) => {
    return new Promise((resolve, reject) => {
      get_json(path, (response) => {
        if (response.error && response.error.includes('Failed to fetch')) {
          reject(new Error(response.error));
        } else {
          resolve(response);
        }
      });
    });
  },

  post: (path, data) => {
    console.log('API.post called:', path, data);
    return new Promise((resolve, reject) => {
      post_json(path, data, (response) => {
        console.log('API.post response:', response);
        if (response.error && response.error.includes('Failed to fetch')) {
          reject(new Error(response.error));
        } else {
          resolve(response);
        }
      });
    });
  },

  delete: (path) => {
    return new Promise((resolve, reject) => {
      delete_json(path, (response) => {
        if (response.error && response.error.includes('Failed to fetch')) {
          reject(new Error(response.error));
        } else {
          resolve(response);
        }
      });
    });
  },

  patch: (path, data) => {
    return new Promise((resolve, reject) => {
      const { get_token } = require('./util');
      const buildApiUrl = (path) => {
        if (!path.startsWith('/api/')) {
          path = '/api/' + path.replace(/^\/+/, '');
        }
        const api_url = window.location.origin;
        return api_url + path;
      };

      const token = get_token();
      fetch(buildApiUrl(path), {
        method: 'PATCH',
        headers: {
          'Authorization': token ? `Bearer ${token}` : undefined,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(resp => resp.json())
      .then(resolve)
      .catch(reject);
    });
  }
};

export default API;
